export default "<loading-indicator></loading-indicator>\n";